import isEmpty from 'lodash.isempty'
import { AddressAPI, AddressPreview } from '../types/Address'
import { CountryItem } from '../reducers/types'

export const getCountryName = (countryList: CountryItem[], isoAlphaThreeCode: string) => {
  if (!isEmpty(countryList)) {
    const countryObj = countryList.find(
      (country) => country.isoAlphaThree?.toLowerCase() === isoAlphaThreeCode.toLocaleLowerCase()
    )
    return countryObj?.isoName || isoAlphaThreeCode
  } else {
    return isoAlphaThreeCode
  }
}

export const formatAddress = (address: AddressAPI, countryList: CountryItem[]): AddressPreview | null => {
  if (isEmpty(address)) return null

  const { streetAddress, city, country, postalCode, state } = address

  const hasStateAndZip = !isEmpty(state) && !isEmpty(postalCode)
  const hasStateOrZip = !isEmpty(state) || !isEmpty(postalCode)

  const addressFormat: AddressPreview = {
    streetAddress1: streetAddress[0],
    streetAddress2: streetAddress[1],
    city,
    StateAndZip: `${!isEmpty(state) ? state : ''}${hasStateAndZip ? ' ' : ''}${!isEmpty(postalCode) ? postalCode : ''}`,
    country: countryList ? getCountryName(countryList, country!) : country,
    hasComma: hasStateOrZip
  }

  return addressFormat
}
